function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { Transport } from "../transport.js";
import { nextTick } from "../globals.node.js";
import { createPacketDecoderStream, createPacketEncoderStream } from "engine.io-parser";
/**
 * WebTransport transport based on the built-in `WebTransport` object.
 *
 * Usage: browser, Node.js (with the `@fails-components/webtransport` package)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebTransport
 * @see https://caniuse.com/webtransport
 */ export var WT = /*#__PURE__*/ function(Transport) {
    "use strict";
    _inherits(WT, Transport);
    function WT() {
        _class_call_check(this, WT);
        return _call_super(this, WT, arguments);
    }
    _create_class(WT, [
        {
            key: "name",
            get: function get() {
                return "webtransport";
            }
        },
        {
            key: "doOpen",
            value: function doOpen() {
                var _this = this;
                try {
                    // @ts-ignore
                    this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
                } catch (err) {
                    return this.emitReserved("error", err);
                }
                this._transport.closed.then(function() {
                    _this.onClose();
                }).catch(function(err) {
                    _this.onError("webtransport error", err);
                });
                // note: we could have used async/await, but that would require some additional polyfills
                this._transport.ready.then(function() {
                    _this._transport.createBidirectionalStream().then(function(stream) {
                        var decoderStream = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, _this.socket.binaryType);
                        var reader = stream.readable.pipeThrough(decoderStream).getReader();
                        var encoderStream = createPacketEncoderStream();
                        encoderStream.readable.pipeTo(stream.writable);
                        _this._writer = encoderStream.writable.getWriter();
                        var read = function() {
                            reader.read().then(function(param) {
                                var done = param.done, value = param.value;
                                if (done) {
                                    return;
                                }
                                _this.onPacket(value);
                                read();
                            }).catch(function(err) {});
                        };
                        read();
                        var packet = {
                            type: "open"
                        };
                        if (_this.query.sid) {
                            packet.data = '{"sid":"'.concat(_this.query.sid, '"}');
                        }
                        _this._writer.write(packet).then(function() {
                            return _this.onOpen();
                        });
                    });
                });
            }
        },
        {
            key: "write",
            value: function write(packets) {
                var _this, _loop = function(i) {
                    var packet = packets[i];
                    var lastPacket = i === packets.length - 1;
                    _this._writer.write(packet).then(function() {
                        if (lastPacket) {
                            nextTick(function() {
                                _this1.writable = true;
                                _this1.emitReserved("drain");
                            }, _this1.setTimeoutFn);
                        }
                    });
                };
                var _this1 = this;
                this.writable = false;
                for(var i = 0; i < packets.length; i++)_this = this, _loop(i);
            }
        },
        {
            key: "doClose",
            value: function doClose() {
                var _a;
                (_a = this._transport) === null || _a === void 0 ? void 0 : _a.close();
            }
        }
    ]);
    return WT;
}(Transport);
